(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.addEventListener('keydown', this.onContainerKeyDown.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
     
      this.elements.panel.hidden = true;
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }


    onContainerKeyDown(event) {
      if (this.elements.panel.hidden) return;
      const links = Array.from(this.querySelectorAll('.disclosure__link'));
      if (!links.length) return;
      const focused = document.activeElement;
      const idx = links.indexOf(focused);

      if (event.code === 'ArrowDown') {
        event.preventDefault();
        const next = idx < links.length - 1 ? links[idx + 1] : links[0];
        next.focus();
      } else if (event.code === 'ArrowUp') {
        event.preventDefault();
        const prev = idx > 0 ? links[idx - 1] : links[links.length - 1];
        prev.focus();
      } else if (event.code === 'Home') {
        event.preventDefault();
        links[0].focus();
      } else if (event.code === 'End') {
        event.preventDefault();
        links[links.length - 1].focus();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      /* FIX: Use .hidden property toggle instead of toggleAttribute for clarity. */
      this.elements.panel.hidden = !this.elements.panel.hidden;
      this.elements.button.setAttribute('aria-expanded', (!this.elements.panel.hidden).toString());
    }

    closeSelector(event) {
      if (!event.relatedTarget || !this.contains(event.relatedTarget)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.querySelectorAll('details').forEach(function(det) {
        var summary = det.querySelector(':scope > summary');
        if (summary) {
          summary.setAttribute('aria-expanded', det.open ? 'true' : 'false');
        }
        det.addEventListener('toggle', function() {
          var summary = det.querySelector(':scope > summary');
          if (summary) {
            summary.setAttribute('aria-expanded', det.open ? 'true' : 'false');
          }
        });
      });

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  var $testimonialSlider = $('.testimonial-sliders');
  // $('.testimonial-sliders').slick({
  //   infinite: true,
  //   arrows: true,
  //     prevArrow: '<button class="slide-arrow prev-arrow arrow"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_1_272a4f29-7b68-4ec2-a665-ee9717c2a40b.png?v=1620381762"></button>',
  //     nextArrow: '<button class="slide-arrow next-arrow arrow"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_2_07737331-514f-4b89-930c-65e318d85cbe.png?v=1620381762"></button>',
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   dots: false,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         dots: false,
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //         infinite: true,
  //         dots: true
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         dots: false,
  //         slidesToShow: 2,
  //         slidesToScroll: 1
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         dots: false,
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ]
  // });

  $testimonialSlider.slick({
    infinite: true,
    arrows: true,
    prevArrow:
      '<button class="slide-arrow prev-arrow arrow" aria-label="Previous testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_1_272a4f29-7b68-4ec2-a665-ee9717c2a40b.png?v=1620381762" alt=""></button>',
    nextArrow:
      '<button class="slide-arrow next-arrow arrow" aria-label="Next testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_2_07737331-514f-4b89-930c-65e318d85cbe.png?v=1620381762" alt=""></button>',
    autoplay: true,
    autoplaySpeed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });

  function updateTestimonialTabindex() {
    $testimonialSlider.find('.slick-slide').each(function () {
      if ($(this).attr('aria-hidden') === 'true') {
        $(this).attr('tabindex', '-1');
        $(this).find('a, button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
      } else {
        $(this).removeAttr('tabindex');
        $(this).find('a, button, input, select, textarea').removeAttr('tabindex');
      }
    });
  }

  $testimonialSlider.on('init reInit afterChange', function () {
    updateTestimonialTabindex();
  });

  // Fix: Cover all other slick slider instances sitewide
  function updateAllSlickTabindex() {
    $('.slick-slide').each(function () {
      if ($(this).attr('aria-hidden') === 'true') {
        $(this).attr('tabindex', '-1');
        $(this).find('a, button, input, select, textarea, [tabindex]').attr('tabindex', '-1');
      } else {
        $(this).removeAttr('tabindex');
        $(this).find('a, button, input, select, textarea').removeAttr('tabindex');
      }
    });
  }

  // Run on page load and after delays to catch all dynamically initialized sliders
  $(document).ready(function () {
    setTimeout(updateAllSlickTabindex, 500);
    setTimeout(updateAllSlickTabindex, 1500);
    setTimeout(updateAllSlickTabindex, 3000);
  });

  // Also hook into any slick afterChange event sitewide
  $(document).on('afterChange', '.slick-slider', function () {
    updateAllSlickTabindex();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('load', function() {
jQuery('.testimonial-slider').slick({
  infinite: true,
  arrows: true,
  // prevArrow: '<button class="slide-arrow prev-arrow arrow" aria-label="Previous testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_1_272a4f29-7b68-4ec2-a665-ee9717c2a40b.png?v=1620381762" alt="" aria-hidden="true"></button>',
  // nextArrow: '<button class="slide-arrow next-arrow arrow" aria-label="Next testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_2_07737331-514f-4b89-930c-65e318d85cbe.png?v=1620381762" alt="" aria-hidden="true"></button>',
  prevArrow: '<button class="slide-arrow prev-arrow arrow" aria-label="Previous testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_1_272a4f29-7b68-4ec2-a665-ee9717c2a40b.png?v=1620381762&format=webp&width=15" alt="" aria-hidden="true" width="15" height="15"></button>',
  nextArrow: '<button class="slide-arrow next-arrow arrow" aria-label="Next testimonial"><img src="https://cdn.shopify.com/s/files/1/0075/2923/4522/files/Polygon_2_07737331-514f-4b89-930c-65e318d85cbe.png?v=1620381762&format=webp&width=15" alt="" aria-hidden="true" width="15" height="15"></button>',
  autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});
});

/* FIX: Pause/play toggle for WCAG 2.2.2 */
jQuery('.carousel-pause-btn').on('click', function() {
  var $slider = jQuery('#' + jQuery(this).data('slider-id'));
  if ($slider.length) {
    var isPaused = $slider.slick('slickGetOption', 'autoplay');
    if (isPaused) {
      $slider.slick('slickPause');
      jQuery(this).text('Play').attr('aria-label', 'Play testimonial carousel');
    } else {
      $slider.slick('slickPlay');
      jQuery(this).text('Pause').attr('aria-label', 'Pause testimonial carousel');
    }
  }
});

  } catch(e) { console.error(e); }
})();
})();
